import { cn } from "@/lib/utils";
import AppHeader from "@/components/AppHeader";
import { Separator } from "@/components/ui/separator";
import { ReactNode } from "react";

interface CourseHeaderProps {
  title: string;
  courseTitle: string;
  actions?: ReactNode;
  info?: ReactNode;
  className?: string;
}

export const CourseHeader = ({
  title,
  courseTitle,
  actions,
  info,
  className,
}: CourseHeaderProps) => {
  return (
    <div className={cn("max-w-5xl mx-auto mb-6", className)}>
      <div className="flex items-center justify-between mb-4">
        <AppHeader primary={title} secondary={courseTitle} />
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {info && <div className="flex items-center gap-4 text-sm">{info}</div>}
      <Separator className="mt-8" />
    </div>
  );
};
